import MylibBanner from './src/components/Banner.vue';
import AlLink from './src/components/core/basics/AlLink.vue';
import AlLoading from './src/components/core/loading/AlLoading.vue';
import AlButton from './src/components/core/form-elements/buttons/AlButton.vue';
import SidePanel from './src/components/core/panel/SidePanel.vue';
import AlTooltip from './src/components/core/tooltip/AlTooltip.vue';
import AlIcon from './src/components/core/inline/icon/AlIcon.vue';
import PlayvoxLogo from './src/components/core/inline/icon/PlayvoxLogo.vue';
import AlGrid from './src/components/core/grid/AlGrid.vue';
import AlUser from './src/components/core/user/AlUser.vue';
import AlCard from './src/components/core/card/AlCard.vue';
import AlBadge from './src/components/core/inline/badge/AlBadge.vue';
import AlProgress from './src/components/core/progress/AlProgress.vue';
import AlCollapse from './src/components/core/collapse/AlCollapse.vue';
import AlParagraph from './src/components/core/block/paragraph/AlParagraph.vue';
import AlBreadcrumb from './src/components/core/breadcrumb/AlBreadcrumb.vue';
import AlBreadcrumbItem from './src/components/core/breadcrumb/AlBreadcrumbItem.vue';
import AlContextualMenu from './src/components/core/contextual-menu/AlContextualMenu.vue';
import AlSelect from './src/components/core/form-components/select/AlSelect.vue';
import ExpandQuestion from './src/components/core/expand-question/ExpandQuestion.vue';
import AlTabs from './src/components/core/tabs/AlTabs.vue';
import AlPagination from './src/components/core/pagination/AlPagination.vue';
import AlMenuSimple from './src/components/core/menu/AlMenuSimple.vue';
import AlDropdown from './src/components/core/dropdown/AlDropdown.vue';
import AlDropdownItem from './src/components/core/dropdown/AlDropdownItem.vue';
import AlDropdownDivider from './src/components/core/dropdown/AlDropdownDivider.vue';
import AlDropdownHeader from './src/components/core/dropdown/AlDropdownHeader.vue';
import AlPopover from './src/components/core/popover/AlPopover.vue';
import AlListGroupItem from './src/components/core/list-group/AlListGroupItem.vue';
import AlListGroup from './src/components/core/list-group/AlListGroup.vue';
import AlSidebar from './src/components/core/sidebar/AlSidebar.vue';
import ContentEditable from './src/components/core/inline/content-editable/ContentEditable.vue';
import AlLinkButton from './src/components/core/form-elements/link-button/AlLinkButton.vue';
import AlCheckbox from './src/components/core/form-components/checkbox/AlCheckbox.vue';
import AlInput from './src/components/core/form-components/input/AlInput.vue';
import AlTextarea from './src/components/core/form-components/textarea/AlTextarea.vue';
import AlInputSearch from './src/components/core/form-components/input/AlInputSearch.vue';
import AlLabel from './src/components/core/form-components/input/AlLabel.vue';
import AlFormRadio from './src/components/core/form-components/radio/AlFormRadio.vue';
import AlFormGroup from './src/components/core/form-components/group/AlFormGroup.vue';
import AlForm from './src/components/core/form-components/form/AlForm.vue';

import SingleNotification from './src/components/modules/notification/SingleNotification.vue';
import NotificationEmptyState from './src/components/modules/notification/NotificationEmptyState.vue';
import NotificationFooter from './src/components/modules/notification/NotificationFooter.vue';
import ActivityNotification from './src/components/modules/notification/ActivityNotification.vue';
import AnnouncementsNotification from './src/components/modules/notification/AnnouncementsNotification.vue';

import AlModal from './src/components/shared/modal/AlModal.vue';
import AlSectionHero from './src/components/shared/header/section-hero/AlSectionHero.vue';
import AlVerticalNavigation from './src/components/shared/navigation/AlVerticalNavigation.vue';
import AlHorizontalNavigation from './src/components/shared/navigation/AlHorizontalNavigation.vue';

import AlTest from './src/directives/AlTest.js';

// Exportación de los componentes individualmente
const components = {
  MylibBanner,
  AlLink,
  AlLoading,
  AlButton,
  SidePanel,
  AlTooltip,
  AlIcon,
  PlayvoxLogo,
  AlGrid,
  AlUser,
  AlCard,
  AlBadge,
  AlProgress,
  AlCollapse,
  AlParagraph,
  AlBreadcrumb,
  AlBreadcrumbItem,
  AlContextualMenu,
  AlSelect,
  ExpandQuestion,
  AlTabs,
  AlPagination,
  AlMenuSimple,
  AlDropdown,
  AlDropdownItem,
  AlDropdownDivider,
  AlDropdownHeader,
  AlPopover,
  AlListGroupItem,
  AlListGroup,
  AlSidebar,
  ContentEditable,
  AlLinkButton,
  AlCheckbox,
  AlInput,
  AlTextarea,
  AlInputSearch,
  AlLabel,
  AlFormRadio,
  AlFormGroup,
  AlForm,
  SingleNotification,
  NotificationEmptyState,
  NotificationFooter,
  ActivityNotification,
  AnnouncementsNotification,
  AlModal,
  AlSectionHero,
  AlVerticalNavigation,
  AlHorizontalNavigation
};

// Instalación de la librería como un plugin
export default {
  install(Vue) {
    Object.keys(components).forEach((key) => {
      Vue.component(key, components[key]);
    });
  }
};

export {
  MylibBanner,
  AlLink,
  AlLoading,
  AlButton,
  SidePanel,
  AlTooltip,
  AlIcon,
  PlayvoxLogo,
  AlGrid,
  AlUser,
  AlCard,
  AlBadge,
  AlProgress,
  AlCollapse,
  AlParagraph,
  AlBreadcrumb,
  AlBreadcrumbItem,
  AlContextualMenu,
  AlSelect,
  ExpandQuestion,
  AlTabs,
  AlPagination,
  AlMenuSimple,
  AlDropdown,
  AlDropdownItem,
  AlDropdownDivider,
  AlDropdownHeader,
  AlPopover,
  AlListGroupItem,
  AlListGroup,
  AlSidebar,
  ContentEditable,
  AlLinkButton,
  AlCheckbox,
  AlInput,
  AlTextarea,
  AlInputSearch,
  AlLabel,
  AlFormRadio,
  AlFormGroup,
  AlForm,
  SingleNotification,
  NotificationEmptyState,
  NotificationFooter,
  ActivityNotification,
  AnnouncementsNotification,
  AlModal,
  AlSectionHero,
  AlVerticalNavigation,
  AlHorizontalNavigation,
  AlTest
};
